<script setup lang="ts">
    import { reactive, ref, defineProps, defineEmits } from 'vue';
    import OnboardingPayslipUploadInput from './components/OnboardingPayslipUploadInput.vue';
    
    interface FormParams {
        user: any;
        photo: any;
    }
    const props = defineProps({
        formParams: { type: Object as () => FormParams, required: true },
        loading: { type: Boolean, default: false }
    });

    const emit = defineEmits(['saved', 'previous']);
    
    const isFormValid = ref(false);
    const formData = reactive({
        bulletin1: null as any,
        bulletin2: null as any,
        bulletin3: null as any,
    });
    const errors = reactive({
        bulletin1: '',
        bulletin2: '',
        bulletin3: '',
    });

    function validate() {
        let isValid = true;

        errors.bulletin1 = '';
        if (!formData.bulletin1) {
            errors.bulletin1 ="Le bulletin 1 est requis";
            isValid = false;
        }

        errors.bulletin2 = '';
        if (!formData.bulletin2) {
            errors.bulletin2 ="Le bulletin 2 est requis";
            isValid = false;
        }

        errors.bulletin3 = '';
        if (!formData.bulletin3) {
            errors.bulletin3 ="Le bulletin 3 est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    function onFileUploaded(field: 'bulletin1' | 'bulletin2' | 'bulletin3', uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData[field] = { file: uploadedFile.file, name: uploadedFile.file_name };
    }

    function goToPreviousStep() {
        emit('previous');
    }

    async function onSubmit() {
        if (!validate()) { return; }
        emit('saved', formData);
    }

</script>

<template>
    <div>
        <div class="tag-state lg rounded-50 flex align-items-center gap-4 px-4 py-4 mb-6">
            <img :src="formParams.photo?.preview ? formParams.photo.preview : '/assets/users/300w/user2.jpg'" class="rounded-100 overflow-hidden size-2xl" />
            <div class="px-3">
                <h5 class="my-1">{{ formParams.user.nom + ' ' + formParams.user.prenom }}</h5>
                {{ formParams.user.email + ' | ' + formParams.user.telephone }}
            </div>
            <div class="rounded-100 overflow-hidden size-2xl ml-auto">
                <img src="/icons/icon-coop-finance.svg" width="100%" />
            </div>
        </div>

        <h2 class="font-semibold text-center my-6">Charger vos 3 derniers bulletins de salaire</h2>

        <form class="form">
            <onboarding-payslip-upload-input 
                id="bulletin1-upload" 
                @uploaded="onFileUploaded('bulletin1', $event)" 
                caption=".1"
                label="Bulletin de salaire (1)"
                required />

            <onboarding-payslip-upload-input 
                id="bulletin2-upload" 
                @uploaded="onFileUploaded('bulletin2', $event)" 
                caption=".2"
                label="Bulletin de salaire (2)"
                required />

                
            <onboarding-payslip-upload-input 
                id="bulletin3-upload" 
                @uploaded="onFileUploaded('bulletin3', $event)" 
                caption=".3"
                label="Bulletin de salaire (3)"
                required />

            <p class="text-read text-grey-600 text-center mt-6">
                Format de fichier supporté: PDF, DOC, XLS. Taille max: 5MB.
            </p>

            <custom-button type="button" id="btn-save-payslip-documents" @click="onSubmit" class="btn lg w-100 flex-center mt-5 mb-6" :loading="props.loading">
                <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                <span>Valider</span>
            </custom-button>

            <a href="javascript:;" @click.prevent="goToPreviousStep">
                <h5 class="flex-center gap-4 text-primary-color text-center">
                    <img src="/icons/icon-back.svg" class="size-medium" alt="" /> 
                    Etape précedente
                </h5>
            </a>
        </form>
    </div>
</template>
